import {
    cibCcAmex,
    cibCcApplePay,
    cibCcMastercard,
    cibCcPaypal,
    cibCcStripe,
    cibCcVisa,
    cibFacebook,
    cibGoogle,
    cibLinkedin,
    cibSkype,
    cibTwitter,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAccountLogout,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilBriefcase,
    cilCalculator,
    cilCalendar,
    cilCart,
    cilChart,
    cilChartPie,
    cilCheck,
    cilChevronLeft,
    cilChevronRight,
    cilCloudDownload,
    cilCloudUpload,
    cilCode,
    cilCog,
    cilCommentSquare,
    cilContrast,
    cilCreditCard,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEqualizer,
    cilFile,
    cilGraph,
    cilGrid,
    cilGroup,
    cilHeadphones,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInputPower,
    cilItalic,
    cilJustifyCenter,
    cilLanguage,
    cilLayers,
    cilList,
    cilListNumbered,
    cilListRich,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMediaPlay,
    cilMediaRecord,
    cilMenu,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperPlane,
    cilPaperclip,
    cilPen,
    cilPencil,
    cilPeople,
    cilPrint,
    cilPuzzle,
    cilReportSlash,
    cilSave,
    cilSearch,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilSitemap,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilStorage,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserPlus,
    cilUserUnfollow
} from '@coreui/icons';

export const iconSubset = {
    cibCcAmex,
    cibCcApplePay,
    cibCcMastercard,
    cibCcPaypal,
    cibCcStripe,
    cibCcVisa,
    cibFacebook,
    cibGoogle,
    cibLinkedin,
    cibSkype,
    cibTwitter,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAccountLogout,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilBriefcase,
    cilCalculator,
    cilCalendar,
    cilCart,
    cilChart,
    cilChartPie,
    cilCheck,
    cilChevronLeft,
    cilChevronRight,
    cilCloudDownload,
    cilCloudUpload,
    cilCode,
    cilCog,
    cilCommentSquare,
    cilContrast,
    cilCreditCard,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEqualizer,
    cilFile,
    cilGraph,
    cilGrid,
    cilGroup,
    cilHeadphones,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInputPower,
    cilItalic,
    cilJustifyCenter,
    cilLanguage,
    cilLayers,
    cilList,
    cilListNumbered,
    cilListRich,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMediaPlay,
    cilMediaRecord,
    cilMenu,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperPlane,
    cilPaperclip,
    cilPen,
    cilPencil,
    cilPeople,
    cilPrint,
    cilPuzzle,
    cilReportSlash,
    cilSave,
    cilSearch,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilSitemap,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilStorage,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserPlus,
    cilUserUnfollow,
};

export enum IconSubset {
    cibCcAmex = 'cibCcAmex',
    cibCcApplePay = 'cibCcApplePay',
    cibCcMastercard = 'cibCcMastercard',
    cibCcPaypal = 'cibCcPaypal',
    cibCcStripe = 'cibCcStripe',
    cibCcVisa = 'cibCcVisa',
    cibFacebook = 'cibFacebook',
    cibGoogle = 'cibGoogle',
    cibLinkedin = 'cibLinkedin',
    cibSkype = 'cibSkype',
    cibTwitter = 'cibTwitter',
    cifBr = 'cifBr',
    cifEs = 'cifEs',
    cifFr = 'cifFr',
    cifIn = 'cifIn',
    cifPl = 'cifPl',
    cifUs = 'cifUs',
    cilAccountLogout = 'cilAccountLogout',
    cilAlignCenter = 'cilAlignCenter',
    cilAlignLeft = 'cilAlignLeft',
    cilAlignRight = 'cilAlignRight',
    cilApplicationsSettings = 'cilApplicationsSettings',
    cilArrowBottom = 'cilArrowBottom',
    cilArrowRight = 'cilArrowRight',
    cilArrowTop = 'cilArrowTop',
    cilBasket = 'cilBasket',
    cilBell = 'cilBell',
    cilBold = 'cilBold',
    cilBookmark = 'cilBookmark',
    cilCalculator = 'cilCalculator',
    cilCalendar = 'cilCalendar',
    cilCart = 'cilCart',
    cilChart = 'cilChart',
    cilChartPie = 'cilChartPie',
    cilCheck = 'cilCheck',
    cilChevronLeft = 'cilChevronLeft',
    cilChevronRight = 'cilChevronRight',
    cilCloudDownload = 'cilCloudDownload',
    cilCode = 'cilCode',
    cilCommentSquare = 'cilCommentSquare',
    cilContrast = 'cilContrast',
    cilCreditCard = 'cilCreditCard',
    cilCursor = 'cilCursor',
    cilDescription = 'cilDescription',
    cilDollar = 'cilDollar',
    cilDrop = 'cilDrop',
    cilEnvelopeClosed = 'cilEnvelopeClosed',
    cilEnvelopeOpen = 'cilEnvelopeOpen',
    cilFile = 'cilFile',
    cilGrid = 'cilGrid',
    cilHome = 'cilHome',
    cilInbox = 'cilInbox',
    cilIndentDecrease = 'cilIndentDecrease',
    cilIndentIncrease = 'cilIndentIncrease',
    cilItalic = 'cilItalic',
    cilJustifyCenter = 'cilJustifyCenter',
    cilLanguage = 'cilLanguage',
    cilLayers = 'cilLayers',
    cilList = 'cilList',
    cilListNumbered = 'cilListNumbered',
    cilListRich = 'cilListRich',
    cilLocationPin = 'cilLocationPin',
    cilLockLocked = 'cilLockLocked',
    cilMagnifyingGlass = 'cilMagnifyingGlass',
    cilMap = 'cilMap',
    cilMediaPlay = 'cilMediaPlay',
    cilMediaRecord = 'cilMediaRecord',
    cilMenu = 'cilMenu',
    cilMoon = 'cilMoon',
    cilNotes = 'cilNotes',
    cilOptions = 'cilOptions',
    cilPaperclip = 'cilPaperclip',
    cilPaperPlane = 'cilPaperPlane',
    cilPen = 'cilPen',
    cilPencil = 'cilPencil',
    cilPeople = 'cilPeople',
    cilPrint = 'cilPrint',
    cilPuzzle = 'cilPuzzle',
    cilReportSlash = 'cilReportSlash',
    cilSave = 'cilSave',
    cilSearch = 'cilSearch',
    cilSettings = 'cilSettings',
    cilShare = 'cilShare',
    cilShareAll = 'cilShareAll',
    cilShareBoxed = 'cilShareBoxed',
    cilSpeech = 'cilSpeech',
    cilSpeedometer = 'cilSpeedometer',
    cilSpreadsheet = 'cilSpreadsheet',
    cilStar = 'cilStar',
    cilSun = 'cilSun',
    cilTags = 'cilTags',
    cilTask = 'cilTask',
    cilTrash = 'cilTrash',
    cilUnderline = 'cilUnderline',
    cilUser = 'cilUser',
    cilUserFemale = 'cilUserFemale',
    cilUserFollow = 'cilUserFollow',
    cilUserPlus = 'cilUserPlus',
    cilUserUnfollow = 'cilUserUnfollow',
    logo = 'logo',
    signet = 'signet'
}

